













import { editFactory } from '@/main/pages';

import { NAME, PP, ND } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: {
				[PP]: PP,
				[ND]: ND,
			},
		};
	},
	methods: {
		async loadData() {
			await this.fetchTableSchemas();
			await this.fetchTableData();
		},
	},
});
